// extracted by mini-css-extract-plugin
export default {"subAccordionSections":"subAccordionSections---mmjUk","sub2Headings":"sub2Headings---suVqm"};